export default __webpack_public_path__ + "static/media/To Overcome Crisis.4a313304.png";